import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";

const S02 = (props) => {
    const client = useRadioInput({
        name: "client[privateperson]", label: "Kjøpte du som privatperson?",
        options: {
            data: [
                { label: "Ja", value: "TRUE" },
                { label: "Nei, som næringsdrivende", value: "FALSE" },
            ],
        },
        ...props,
    })

    const counterpart = useRadioInput({
        name: "counterpart[type]", label: "Hvem har du kjøpt av?",
        options: {
            data: [
                { label: "En privatperson", value: "PRIVATEPERSON" },
                { label: "En forhandler/næringsdrivende", value: "COMPANY" },
                { label: "Kjøpt gjennom et mellomledd (formidlingssalg)", value: "INTERMEDIARY" },
            ],
        },
        ...props,
    })

    return (
        <Wrapper {...props} header="Fortell oss om kjøpet">
            <RadioInput {...client.props}/>
            <RadioInput {...counterpart.props} className="mt-7"/>
        </Wrapper>
    );
};

export default S02;
